<template>
  <div class="table-tdrow" v-if="data">
    <div
      v-for="header in headers"
      class="table-td"
      :key="header.id"
      :class="header.class"
    >
      <span class="infoamout">{{data[header.column]}}</span>
      <span class="infotextspan" v-if="header.footerDesc" v-html="header.footerDesc"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['headers', 'data'],
};
</script>
